import { ICommandBarStyles, ITheme } from '@fluentui/react';
import { Theme } from '../../Models/Constants/Enums';
import '../../Resources/Styles/BaseStyles.scss';

export const getCommandBarStyles = (
    _themeSetting: Theme,
    _theme: ITheme
): Partial<ICommandBarStyles> => {
    return {
        root: {
            backgroundColor: 'var(--color-text-primary)'
        },
        secondarySet: {
            selectors: {
                '.ms-Button': {
                    background: 'transparent',
                    color: 'var(--cb-app-color-command-button-text) !important'
                },
                '.ms-Button:hover': {
                    background: 'var(--cb-app-color-command-button-hover)'
                },
                i: {
                    color: 'var(--cb-app-color-command-button-text) !important'
                }
            }
        }
    };
};
